export enum NetworkSecurityInternetGetters {
    GET_FORM_VALUES = 'GET_FORM_VALUES',
}
